export default __webpack_public_path__ + "static/media/sync_problem.d4f11a4f.svg";